
<component
  :is="as"
  :class="['align', { collapse, 'collapse-end': collapseEnd, flex, 'small-gap': smallGap, 'no-gap': noGap, wrap }]"
  :style="{ 'align-items': direction, 'justify-content': justify }"
  v-bind="$attrs"
  v-on="$listeners"
>
  <slot />
</component>
